module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-info--wrapper"
  }, [_c('div', {
    staticClass: "client-info--content"
  }, [_c('div', {
    staticClass: "full-w flex wrap end"
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "flex-end"
    }
  }, [_c('el-col', {
    attrs: {
      "md": 18,
      "sm": 24
    }
  }, [_c('div', {
    staticClass: "flex-column start"
  }, [_c('span', {
    staticClass: "clientName"
  }, [_vm._v(_vm._s(_vm.currentClient.companyName || ((_vm.currentClient.firstName) + " " + (_vm.currentClient.lastName))))]), _vm._v(" "), (_vm.currentClient.clientType && _vm.currentClient.clientType.id !== undefined) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.currentClient.clientType.id != 1 ? _vm.$t('layouts.header.company') : _vm.$t('layouts.header.individual')))]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "sm": 24
    }
  }, [_c('div', {
    staticClass: "flex-column"
  }, [_c('router-link', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "to": ("/clients/" + (_vm.currentClient.id) + "/edit")
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('layouts.header.viewClient')) + "\n            ")])], 1)])], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "inverted"
  }), _vm._v(" "), _c('p'), (_vm.isBillEdit === true) ? _c('div', {
    staticClass: "address-wrap"
  }, [(_vm.billingAddressMissing === true) ? _c('p', {
    staticClass: "fa fa-info missing-bill-address"
  }, [_vm._v("  " + _vm._s(_vm.$t('static.clientInfo.billAddressMissing')) + " "), _c('span', {
    staticClass: "fa fa-arrow-right"
  })]) : _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.billAddress.care_of) ? _c('span', [_c('strong', [_vm._v("c/o")]), _vm._v(" " + _vm._s(("" + (_vm.billAddress.care_of)))), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), (_vm.billAddress.street_name) ? _c('span', [_vm._v(" " + _vm._s(("" + (_vm.billAddress.street_name)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.billAddress.second_street_name) ? _c('span', [_vm._v(_vm._s(("" + (_vm.billAddress.second_street_name)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.billAddress.postal_code) ? _c('span', [_vm._v(_vm._s(("" + (_vm.billAddress.postal_code))))]) : _vm._e(), _vm._v(" "), (_vm.billAddress.city) ? _c('span', [_vm._v(_vm._s(("" + (_vm.billAddress.city)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.billAddress.country && _vm.billAddress.country.name) ? _c('span', [_vm._v(_vm._s(("" + (_vm.billAddress.country.name))))]) : _vm._e()]), _vm._v(" "), (_vm.currentEdiOrder.orderType !== 'EDI') ? _c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "type": "button",
      "round": ""
    },
    on: {
      "click": _vm.editClientAddress
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "address-wrap"
  }, [(!_vm.currentEdiOrder.id) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.currentClient.deliveryAddress.care_of) ? _c('span', [_c('strong', [_vm._v("c/o")]), _vm._v(" " + _vm._s(("" + (_vm.currentClient.deliveryAddress.care_of)))), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), (_vm.currentClient.deliveryAddress.street_name) ? _c('span', [_vm._v(" " + _vm._s(("" + (_vm.currentClient.deliveryAddress.street_name)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.deliveryAddress.second_street_name) ? _c('span', [_vm._v(_vm._s(("" + (_vm.currentClient.deliveryAddress.second_street_name)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.deliveryAddress.postal_code) ? _c('span', [_vm._v(_vm._s(((_vm.currentClient.deliveryAddress.postal_code) + " " + (_vm.currentClient.deliveryAddress.city_name)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.deliveryAddress.country) ? _c('span', [_vm._v(_vm._s(("" + (_vm.currentClient.deliveryAddress.country))))]) : _vm._e()]) : _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.currentClient.careOf) ? _c('span', [_c('strong', [_vm._v("c/o")]), _vm._v(" " + _vm._s(("" + (_vm.currentClient.careOf)))), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), (_vm.currentClient.streetName) ? _c('span', [_vm._v(" " + _vm._s(("" + (_vm.currentClient.streetName)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.secondStreetName) ? _c('span', [_vm._v(_vm._s(("" + (_vm.currentClient.secondStreetName)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.cityName) ? _c('span', [_vm._v(_vm._s(((_vm.currentClient.postalCode) + " " + (_vm.currentClient.cityName)))), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.currentClient.country) ? _c('span', [_vm._v(_vm._s(("" + (_vm.currentClient.country))))]) : _vm._e()]), _vm._v(" "), (_vm.currentEdiOrder.orderType !== 'EDI') ? _c('button', {
    staticClass: "el-button el-button--default small",
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "type": "button",
      "round": ""
    },
    on: {
      "click": _vm.editClientAddress
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  })]) : _vm._e()]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "fa fa-phone"
  }, [(_vm.currentClient.phoneNumber) ? _c('span') : _vm._e(), _vm._v("  " + _vm._s(_vm.currentClient.phoneNumber))]), _vm._v(" "), (_vm.currentClient.mobileNumber) ? _c('span', [_vm._v(" |  " + _vm._s(_vm.currentClient.mobileNumber))]) : _vm._e()]), _vm._v(" "), (_vm.currentClient.email) ? _c('p', [_c('span', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v("  "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.currentClient.email
    }
  }, [_vm._v(_vm._s(_vm.currentClient.email))])]) : _vm._e(), _vm._v(" "), (_vm.currentClient.contactFirstname || _vm.currentClient.contactLastname) ? _c('p', [_c('span', {
    staticClass: "fa fa-user-o"
  }), _vm._v("  " + _vm._s(((_vm.currentClient.contactFirstname) + " " + (_vm.currentClient.contactLastname))) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbc9ecaa","hasScoped":false}!./src/app/components/clientInfo/clientInfo.html
// module id = 3123
// module chunks = 1